import {
  Box,
  Card,
  CardContent,
  CardHeader,
  CardMedia,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { indigo } from "@material-ui/core/colors";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { ErrorUnexpected } from "../../../const/Messages";
import * as DocumentArticleService from "../../../service/DocumentArticleService";
import * as DocumentSectionService from "../../../service/DocumentSectionService";

const useStyles = makeStyles({
  root: {
    maxWidth: 345,
  },
  card: {
    display: "flex",
    alignItems: "center",
    height: "100%",
  },
  media: {
    height: 50,
    width: 50,
    marginLeft: 15,
    marginTop: 5,
    objectFit: "contain",
  },
  cardContent: { flexGrow: 1, paddingTop: 0 },
  cardBody: { display: "flex", flexDirection: "column", height: "100%" },
});

export default function DocumentList() {
  const [dataPin, setDataPin] = useState([]);
  const [dataSection, setDataSection] = useState([]);

  useEffect(() => {
    updateData();
  }, []);

  const updateData = () => {
    DocumentArticleService.getAllPin()
      .then(setDataPin)
      .catch(() => toast.error(ErrorUnexpected));

    DocumentSectionService.getAllSortedByOrder()
      .then(setDataSection)
      .catch(() => toast.error(ErrorUnexpected));
  };

  const classes = useStyles();

  return (
    <Box>
      <Card>
        <CardHeader
          title={
            <Typography variant="h5" sx={{ fontWeight: "bold" }}>
              Document
            </Typography>
          }
          style={{ maxHeight: 60 }}
        />
      </Card>
      <Grid container spacing={2} style={{ marginTop: "10px" }}>
        {dataPin.map((card) => (
          <Grid item xs={12} md={3} key={card.id}>
            <Card className={classes.card}>
              <CardMedia
                className={classes.media}
                image={card.img}
                component={"img"}
                width={50}
              />
              <CardContent className={classes.cardContent}>
                <Typography variant="h6">{card.sectionTitle}</Typography>
                <Link
                  to={`/document/${card.id}`}
                  style={{ textDecoration: "none" }}
                >
                  <Typography
                    color={indigo.A400}
                    fontWeight="bold"
                    fontSize={14}
                  >
                    {card.title}
                  </Typography>
                </Link>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Grid container spacing={2} paddingTop={8}>
        {dataSection.map((card) => (
          <Grid item xs={12} md={4} key={card.id}>
            <Card className={classes.cardBody}>
              <CardMedia
                component="img"
                src={card.img}
                alt={card.title}
                className={classes.media}
              />
              <CardContent className={classes.cardContent}>
                <Typography variant="h6">{card.title}</Typography>
                {card.articles.map((link) => (
                  <Link
                    key={link.id}
                    to={`/document/${link.id}`}
                    style={{ textDecoration: "none" }}
                  >
                    <Typography variant="body2" color={indigo[400]}>
                      {link.title}
                    </Typography>
                  </Link>
                ))}
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
